<template>
  <span class="base-pill-container">
    {{ label }}
  </span>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "BasePill",
})
export default class BasePill extends Vue {
  @Prop({ default: "" }) readonly label!: string;
}
</script>

<style lang="scss" scoped>
.base-pill-container {
  font-size: 8px;
  font-weight: 600;
  color: $primary_color;
  border: 1px solid $primary_color;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
}
</style>
